import { createSlice } from "@reduxjs/toolkit";

export interface ImageSelectorState {
  readonly isImageSelectorPanelExpanded: boolean;
}

export const initialState: ImageSelectorState = {
  isImageSelectorPanelExpanded: true
};

export const imageSelectorSlice = createSlice({
  name: "imageSelector",
  initialState: initialState,
  reducers: {
    resetImageSelector: () => {
      return initialState;
    },
    toggleImageSelectorExpanded: state => {
      state.isImageSelectorPanelExpanded = !state.isImageSelectorPanelExpanded;
    }
  }
});

export const { toggleImageSelectorExpanded } = imageSelectorSlice.actions;
export default imageSelectorSlice.reducer;
